import React, {useEffect, useState} from 'react';
import {
    CircularProgress,
    Divider,
    Grid,
    Paper,
    Typography,
} from "@material-ui/core";
import {Alert} from '@material-ui/lab';
import useStyles from '../styles/styles';
import {useQuery, useLazyQuery} from "@apollo/react-hooks";
import {gql} from "apollo-boost";
//Detail Components
import ContactCard from '../components/CardDetails/ContactCard';
import ServicersDetailTable from '../components/Servicers/ServicersDetailTable';
import RenderCard from "../components/CardDetails/RenderCard";
import useCardStyles from "../styles/cardStyles";
import CampaignCard from "../components/CardDetails/CampaignCard";
import SettingsIcon from "@material-ui/icons/Settings";
import PortfolioCard from "../components/CardDetails/PortfolioCard";

const Servicer = ({servicerId}) => {
    const classes = useStyles();
    const cardClasses = useCardStyles();
    const [servicerData, setServicerData] = useState(false);
    const limit = 30;
    const [skipVal, setSkipVal] = useState(0);
    const [variables, setVariables] = useState({});
    const [page, setPage] = useState(1);
    const [open, setOpen] = useState('');
    const [modalData, setModalData] = useState({});
    const [glob, setGlob] = useState(null);
    const {loading, error, data} = useQuery(gql`
        query ServicerPage($servicerId: String!) {
            servicer(id: $servicerId) {
                id
                active
                email
                name
                phone
                website
                choiceOfLaw
                brandingContactInformation {
                    name
                    email
                    phone
                    website
                }
                config {
                    key
                    value
                }
                filterAttributes {
                    hierarchyLevel
                    type
                    description
                    attributeType
                    configKey
                }
                filterLists {
                    id
                    field
                    name
                    type
                    filterListValues (limit: 1) {
                        id
                        value
                    }
                }
                schedules {
                    name
                    federalObservances
                    timeZone
                    available {
                        dayOfWeek
                        ranges {
                            opening
                            closing
                        }
                    }
                }
                scheduleInStates {
                    states
                    schedule {
                        name
                        federalObservances
                        timeZone
                        available{
                            dayOfWeek
                            ranges {
                                opening
                                closing
                            }
                        }
                    }
                }
                portfolios {
                    id
                    active
                    email
                    name
                    phone
                    website
                    choiceOfLaw
                    brandingContactInformation {
                        name
                        email
                        phone
                        website
                    }
                    config {
                        key
                        value
                    }
                    filterAttributes {
                        hierarchyLevel
                        type
                        description
                        attributeType
                        configKey
                    }
                    filterLists {
                        id
                        field
                        name
                        type
                        filterListValues(limit: 1) {
                            id
                            value
                        }
                    }
                    schedules {
                        name
                        federalObservances
                        timeZone
                        available {
                            dayOfWeek
                            ranges {
                                opening
                                closing
                            }
                        }
                    }
                    scheduleInStates {
                        states
                        schedule {
                            name
                            federalObservances
                            timeZone
                            available {
                                dayOfWeek
                                ranges {
                                    opening
                                    closing
                                }
                            }
                        }
                    }
                }
            }
            allCampaign {
                nodes {
                    id
                    name
                    servicer {
                        id
                    }
                }
            }
            allTrafficSource {
                nodes {
                    id
                    name
                    legacyPromoId
                    affiliate {
                        id
                        name
                    }
                }
            }
            allAffiliate {
                nodes {
                    id
                    name
                    key
                }
            }
        }
    `, {
        variables: {
            servicerId
        }
    });

    const [runQuery, {loading: filterLoading, data: filterData,}] = useLazyQuery(gql`
        query FilterValues($id: UUID, $limit: Int, $skip: Long, $glob: String) {
            allCampaignFilterListValue(
                filter: {
                    campaignFilterListId: $id
                    value: {
                        glob: $glob
                    }
                }
                limit: $limit
                skip: $skip
            ) {
                totalCount
                nodes {
                    id
                    type
                    value
                }
            }
        }
    `, {
        variables: {
            id: variables.id,
            skip: skipVal,
            limit,
            glob: glob ? `*${glob}*` : null
        },
        fetchPolicy: "network-only",
    });

    const setData = (obj, hierarchyLevel) => {
        const newAttributes = [];
        obj.filterAttributes.forEach((item) => {
            const {attributeType, type} = item;
            const isSame = newAttributes.filter(obj => obj.attributeType === attributeType && obj.type === type);
            if (attributeType !== 'FILTER_LIST' && isSame.length) {
                const existingIndex = newAttributes.indexOf(isSame[0]);
                newAttributes[existingIndex].description = newAttributes[existingIndex].description.concat({
                    value: item.description,
                    configKey: item.configKey
                });
            } else {
                newAttributes.push({
                    ...item,
                    description: [{
                        value: item.description,
                        configKey: item.configKey
                    }]
                });
            }
        });
        obj.filterAttributes = newAttributes;
        //Replace TrafficSource UUID / Affiliate Keys
        obj.filterAttributes.forEach((item) => {
            const {attributeType, description, type} = item;
            if (attributeType === 'LEAD_SOURCE') {
                let trafficSource = [];
                let affiliateSource = [];
                let referringSiteUrls = [];
                description.forEach(source => {
                    if (source) {
                        const { value, configKey } = source;
                        const sourceVal = value.includes('=') ? value.split('=') : '';
                        if (sourceVal[0] === 'trafficSourceUUID') {
                            const tsSubCode = sourceVal[1].includes('subcode');
                            let trafficSourceVal = tsSubCode ? sourceVal[1].split(',') : sourceVal[1];
                            if (tsSubCode) {
                                trafficSourceVal = trafficSourceVal[0];
                            }
                            let ts = data.allTrafficSource.nodes.filter(ts => ts.id === trafficSourceVal)[0];
                            if (ts) {
                                trafficSource.push({
                                    ...ts,
                                    subCode: tsSubCode ? sourceVal[2] : false,
                                    configKey,
                                    key: false
                                });
                            }
                        }
                        if (sourceVal[0] === 'affiliateKey' || sourceVal[0] === 'affiliateUUID') {
                            const key = sourceVal[0] === 'affiliateUUID' ? 'id' : 'key';
                            const affiliateSubCode = sourceVal[1].includes('subcode') || sourceVal[1].includes('subcodeHash');
                            let affiliatesVal = affiliateSubCode ? sourceVal[1].split(',') : sourceVal[1];

                            if (affiliateSubCode) {
                                affiliatesVal = affiliatesVal[0];
                            }
                            let affiliates = data.allAffiliate.nodes.filter(af => af[key] === affiliatesVal)[0];
                            if (affiliates) {
                                affiliateSource.push({
                                    ...affiliates,
                                    configKey,
                                    affiliate: false,
                                    subCode: affiliateSubCode ? sourceVal[2] : false,
                                });
                            }
                        }
                        if (sourceVal[0] === 'referringSiteUrl'){
                            const hasAffiliateKey = sourceVal[1].includes('affiliateKey');
                            const affiliateKey =  hasAffiliateKey ? sourceVal[2] : '';
                            const value = hasAffiliateKey ? sourceVal[1].split(',')[0] : sourceVal[1]
                            if(value){
                                referringSiteUrls.push({
                                    configKey,
                                    referringSiteUrl: value,
                                    key: affiliateKey
                                })
                            }
                        }
                    }
                });
                item.sources = {
                    type,
                    trafficSource,
                    affiliateSource,
                    referringSiteUrls
                };
            }
        });
        // Configs
        if (obj.config.length) {
            const config = {
                attributeType: 'Configs',
                description: [
                    ...obj.config
                ],
                hierarchyLevel,
                id: `config-${hierarchyLevel}`,
                type: () => <SettingsIcon />
            };
            obj.filterAttributes.unshift(config);
        }

        return obj;
    }

    useEffect(() => {
        if (data && Object.keys(data).length && data.servicer && !servicerData) {
            //Set Servicer
            data.servicer = setData(data.servicer, 'SERVICER');
            data.servicer.campaigns = data.allCampaign.nodes.filter(item => item.servicer.id === data.servicer.id);
            //Set Portfolios
            data.servicer.portfolioArr = [];
            data.servicer.portfolios.forEach(item => {
                const newItem = setData(item, 'Portfolio');
                data.servicer.portfolioArr.push(newItem);
            });
            setServicerData(data.servicer);
        }
    }, [data])

    useEffect(() => {
        if (filterData && Object.keys(filterData).length) {
            const {nodes, totalCount} = filterData.allCampaignFilterListValue;
            if (filterData) {
                setModalData({
                    numberOfPages: Math.ceil(totalCount / limit) === 0 ? 1 : Math.ceil(totalCount / limit),
                    nodes,
                    totalCount
                });
            } else {
                setModalData(m => ({
                    ...m,
                    totalCount: 0,
                    nodes: [],
                }));
            }
        }
    }, [filterData])

    useEffect(() => {
        if (Object.keys(variables).length && variables.id) {
            runQuery();
        }
    }, [variables]);

    const handleOpen = (id, data) => {
        setModalData({
            id,
            numberOfPages: 0,
            totalCount: 0,
            nodes: []
        });
        setVariables({
            id
        });
        setOpen(id);
    };

    const handleClose = () => {
        setModalData({});
        setGlob(null);
        setOpen('');
        setPage(1);
        setVariables({});
    };

    const handleSubmit = (event, searchVal) => {
        if (event) {
            event.preventDefault();
        }
        setGlob(searchVal);
        setSkipVal(0);
        setPage(1);
    }

    const getActualFilterListName = (filterListName) => {
        const exclusiveString = ' (only applied on exclusive traffic)'
        if (filterListName.endsWith(exclusiveString)){
            return filterListName.replace(exclusiveString, '')
        }
        return filterListName
    }


    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Paper className={classes.paper} style={{marginBottom: '10px'}}>
                    {!loading && error ? (
                        <Alert severity="error">There is an error!</Alert>
                    ) : null}
                    {loading ? (
                        <div className={classes.loadingBar}>
                            <CircularProgress
                                size={50}
                                thickness={4}
                            />
                        </div>
                    ) : null}
                    {!loading && servicerData ? (
                        <>
                            <Typography variant="h5" noWrap>{`Servicer - ${servicerData.id}`}</Typography>
                            <ServicersDetailTable
                                classes={classes}
                                servicerData={servicerData}
                                handleOpen={handleOpen}
                            />
                        </>
                    ) : null}
                </Paper>
            </Grid>

            {!loading && servicerData ? (
                <>
                    {!servicerData.active ? (
                        <Grid item xs={12}>
                            <Alert severity="error">This servicer is not active!</Alert>
                        </Grid>
                    ) : null}
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <ContactCard
                            contactData={servicerData.brandingContactInformation || {}}
                            title="Branding Contact Info"
                            cardClasses={cardClasses}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <CampaignCard
                            campaigns={servicerData.campaigns}
                            cardClasses={cardClasses}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <PortfolioCard
                            portfolios={servicerData.portfolioArr}
                            cardClasses={cardClasses}
                        />
                    </Grid>
                    {servicerData.filterAttributes.map((attribute, idx) => {
                        let filterList;
                        if (attribute.attributeType === 'FILTER_LIST') {
                            filterList = servicerData.filterLists.find(fl => fl.name === getActualFilterListName(attribute.description[0].value))
                        } else if (attribute.attributeType === 'SCHEDULE') {
                            attribute.schedules = servicerData.schedules
                        }  else if (attribute.attributeType === 'SCHEDULE_IN_STATE') {
                            attribute.scheduleInStates = servicerData.scheduleInStates;
                        } else if (attribute.attributeType === 'Configs') {
                            attribute.configs = servicerData.configs;
                        }
                        return (
                            <RenderCard
                                key={`${attribute.id}-${idx}`}
                                data={attribute}
                                filterList={filterList}
                                cardClasses={cardClasses}
                                open={open}
                                handleOpen={handleOpen}
                                handleClose={handleClose}
                                classes={classes}
                                page={page}
                                setPage={setPage}
                                filterLoading={filterLoading}
                                skipVal={skipVal}
                                setSkipVal={setSkipVal}
                                limit={limit}
                                modalData={modalData}
                                handleSubmit={handleSubmit}
                            />
                        )
                    })}
                    {servicerData.portfolioArr.length ? (
                        <Grid container spacing={2} style={{ margin: '10px 0'}}>
                            {servicerData.portfolioArr.map(item => {
                                return (
                                    <Grid key={item.id} container spacing={2} style={{ margin: '10px'}} id={`portfolio-${item.id}`}>
                                        <Grid item xs={12}>
                                            <Typography variant="h5" noWrap>{`Portfolio - ${item.id}`}</Typography>
                                            <Divider style={{ margin: '10px 0'}}/>
                                        </Grid>
                                        {!item.active ? (
                                            <Grid item xs={12}>
                                                <Alert severity="error">This portfolio is not active!</Alert>
                                            </Grid>
                                        ) : null}
                                        <Grid item xs={12} sm={6} md={4} lg={3}>
                                            <ContactCard
                                                contactData={item.brandingContactInformation || {}}
                                                title="Branding Contact Info"
                                                cardClasses={cardClasses}
                                            />
                                        </Grid>
                                        {item.filterAttributes.map((attribute, idx) => {

                                            let filterList;
                                            if (attribute.attributeType === 'FILTER_LIST') {
                                                filterList = item.filterLists.find(fl => fl.name === attribute.description[0].value)
                                            } else if (attribute.attributeType === 'SCHEDULE') {
                                                attribute.schedules = item.schedules
                                            }  else if (attribute.attributeType === 'SCHEDULE_IN_STATE') {
                                                attribute.scheduleInStates = item.scheduleInStates;
                                            } else if (attribute.attributeType === 'Configs') {
                                                attribute.configs = item.configs;
                                            }
                                            return (
                                                <RenderCard
                                                    key={`${attribute.id}-${idx}`}
                                                    data={attribute}
                                                    filterList={filterList}
                                                    cardClasses={cardClasses}
                                                    open={open}
                                                    handleOpen={handleOpen}
                                                    handleClose={handleClose}
                                                    classes={classes}
                                                    page={page}
                                                    setPage={setPage}
                                                    filterLoading={filterLoading}
                                                    skipVal={skipVal}
                                                    setSkipVal={setSkipVal}
                                                    limit={limit}
                                                    modalData={modalData}
                                                    handleSubmit={handleSubmit}
                                                />
                                            );
                                        })}
                                    </Grid>
                                );
                            })}
                        </Grid>
                    ) : null}
                </>
            ) : null}
        </Grid>
    );
};

export default Servicer;
